import React, { useEffect } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  useTheme,
  Container,
  Grid,
  useMediaQuery,
  FormControl,
  FormHelperText,
  TextField,
  TextareaAutosize,
  Divider,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useMutation, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import VerificationCode from "./VerificationCode";
import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";

const SAVE_CUSTOMER = gql`
  mutation saveCustomer($customerInput: CustomerInput!) {
    saveCustomer(customerInput: $customerInput)
  }
`;

const GET_COURSES = gql`
  query courses {
    courses {
      futureContents {
        id
        name
        dateStart
        dateEnd
      }
    }
  }
`;

export default function CoursePage() {
  return (
    <Box
      style={{
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <CourseForm />
      <CourseText />
    </Box>
  );
}

function CourseText() {
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:320px)");
  const isPad = useMediaQuery("(max-width:576px)");
  const useStyles = makeStyles((theme) => ({
    gridbox: {
      marginBottom: "50px",
      "& .MuiTypography-h4": {
        fontWeight: 700,
        marginBottom: "50px",
      },
      "& .MuiTypography-h2": {
        fontWeight: 700,
        marginBottom: "50px",
        color: theme.palette.secondary.light,
      },
    },
    gridList: {
      display: "flex",
      alignItems: "center",
      "& .MuiTypography-h2": {
        fontSize: isPhone ? "1.5rem" : isPad ? "2.5rem" : "3.75rem",
        fontWeight: 700,
        margin: "40px 0px",
        color: theme.palette.secondary.light,
      },
      "& .MuiTypography-h6": {
        fontSize: isPhone ? "0.75rem" : isPad ? "1rem" : "1.25rem",
        fontWeight: 700,
      },
      "& .MuiTypography-body1": {
        fontSize: isPhone ? "0.5rem" : isPad ? "0.75rem" : "1rem",
      },
    },
  }));
  const classes = useStyles();
  const classList = [
    {
      itemNumber: "02",
      itemTitle: "法拍屋入門實戰班",
      itemBody: "每月15日下午2點開課；共2天540分鐘，課程費用特價優惠2000元。",
    },
    {
      itemNumber: "03",
      itemTitle: "法拍公司成立要訣基礎班",
      itemBody: "每月16日上午10點開課；共1天，課程費用特價優惠300元。",
    },
    {
      itemNumber: "04",
      itemTitle: "法拍公司成立要訣進階班",
      itemBody: "每月17日上午10點開課；共2天，課程費用特價優惠1000元。",
    },
    {
      itemNumber: "05",
      itemTitle: "法拍創業開發行銷基礎班",
      itemBody: "每月20日下午2點開課；共1天，課程費用特價優惠600元。",
    },
    {
      itemNumber: "06",
      itemTitle: "法拍創業開發行銷進階班",
      itemBody: "每月21日下午2點開課；共2天，課程費用特價優惠1200元",
    },
  ];

  return (
    <Container maxWidth="md">
      <Box>
        <Grid className={classes.gridbox}>
          <Typography variant="h2" style={{ paddingTop: "50px" }}>
            01
          </Typography>
          <Typography variant="h6">法院拍賣全套實務傳授班</Typography>
          <Typography variant="body1" style={{ marginBottom: "50px" }}>
            最新法拍研究院金磚研習課程：
            <br />
            法院拍賣全套實務傳授 【只要８天您就是行家】
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "50px" }}>
            六大特色:
            <br />
            ◎每週上課二晚，三、五日19:00~22:00，共8天24小時。
            <br />
            ◎法拍全套實務，含作業流程、稅費評估、點交、不點交之分析
            及其應注意事項‧‧‧‧‧‧，結業後即可親自上場操作。
            <br />
            ◎首創:實習輔導中心，免費提供實際操作場所，讓您熟能生巧。
            <br />
            ◎首創:法拍教育研究院，終身研習成長環境。
            <br />
            ◎首創業外實習，人人可學，保證學成。
            <br />
            ◎創業或房仲業、地政士業人士兼差之最佳良機。
            <br />
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "50px" }}>
            費用:7000元(含講義、書籍、雜費)
            <br />
            主辦:富屋專業法拍研習中心
            <br />
            上課兼報名地點:台中市南屯區大英西一街61號
            <br />
            電話:(04)2471-7673 FAX:(04)24757108
            <br />
          </Typography>
          <Divider
            variant="middle"
            style={{
              backgroundColor: theme.palette.secondary.light,
              height: "2px",
            }}
          />

          {classList.map((item) => {
            return (
              <>
                <Grid container className={classes.gridList} spacing={2}>
                  <Grid item xs={isPad ? 2 : null}>
                    <Typography variant="h2">{item.itemNumber}</Typography>
                  </Grid>
                  <Grid item xs={isPad ? 10 : null}>
                    <Typography variant="h6">{item.itemTitle}</Typography>
                    <Typography variant="body1">{item.itemBody}</Typography>
                  </Grid>
                </Grid>
                <Divider
                  variant="middle"
                  style={{
                    backgroundColor: theme.palette.secondary.light,
                    height: "2px",
                  }}
                />
              </>
            );
          })}
        </Grid>
      </Box>
    </Container>
  );
}

function CourseForm() {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPad = useMediaQuery("(max-width:576px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
    formGrid: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      "& .MuiFormLabel-root": {
        // fontSize:'14px'+ ' !important',
      },
    },
    alignFlexEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
  }));

  const classes = useStyles();
  const theme = useTheme();
  const Alert = useAlert();
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      fullName: "",
      lineId: "",
      mobile: "",
      course: "無",
      numberOfPeople: "",
      startDate: "",
      endDate: "",
      remark: "",
      vcode: "",
      paymentType: "",
      amount: "",
    },
  });
  const numberOfPeople = useWatch({ name: "numberOfPeople", control });
  const paymentType = useWatch({ name: "paymentType", control });
  const course = useWatch({ name: "course", control });
  const { data: coursesData, loading } = useQuery(GET_COURSES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  const [saveCustomer, { loading: saveCustomerLoading }] = useMutation(
    SAVE_CUSTOMER,
    {
      onCompleted({ saveCustomer }) {
        if (saveCustomer) {
          window.location.reload();
          return Alert.notice("送出成功");
        }
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );
  function _submit(data) {
    const customerInput = {
      customerType: "SERVICE_AREA",
      source: "NETWORK",
      assignStatus: "WAITING_TO_CONTACT",
      remark: `我要上課=>上課人數：${data.numberOfPeople}，${
        course === "無"
          ? "報名檔期：" + data.startDate + "～" + data.endDate + "月"
          : "報名課程：" +
            coursesData?.courses.futureContents.find(
              (item) => item.id === Number(course)
            ).name +
            "\u2002" +
            moment(
              coursesData?.courses.futureContents.find(
                (item) => item.id === Number(course)
              ).dateStart
            ).format("yyyy-MM-DD") +
            "～" +
            moment(
              coursesData?.courses.futureContents.find(
                (item) => item.id === Number(course)
              ).dateEnd
            ).format("yyyy-MM-DD")
      }${data.remark !== "" ? "，備註：" + data.remark : ""}`,
      customerInfo: [
        {
          fullName: data.fullName,
          mobile1: data.mobile,
          line: data.lineId,
        },
      ],
      frontSite: true,
      courseId: course !== "無" ? Number(course) : undefined,
      numberOfPeople: Number(numberOfPeople),
    };
    // console.log(customerInput.remark);
    saveCustomer({ variables: { customerInput } });
  }

  useEffect(() => {
    if (numberOfPeople === "1") setValue("amount", 2000);
    else setValue("amount", Number(numberOfPeople) * 1500);
  }, [numberOfPeople]);

  return (
    <Container maxWidth="md" style={{ height: "100%" }}>
      <LoadingModal loading={saveCustomerLoading || loading} />
      <Box className={classes.formGrid}>
        {/* form area */}
        <Grid container>
          {/* title */}
          <Grid xs={12} item>
            <Box mb={isTable ? 1 : 2}>
              <Typography
                variant={isTable ? "h4" : "h2"}
                align="center"
                style={{
                  fontWeight: 700,
                  color: theme.palette.secondary.light,
                }}
              >
                我要上課
              </Typography>
            </Box>
          </Grid>
          {/* title area end */}
          {/* form */}
          <Grid
            container
            xs={12}
            justify={isPhone ? "space-between" : "flex-start"}
            spacing={2}
          >
            {/* ANCHOR 姓名 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="fullName"
                control={control}
                rules={{
                  required: "請輸入姓名",
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      姓名
                    </Typography>

                    <TextField
                      placeholder="姓名"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR Line 帳號 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="lineId"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      Line帳號
                    </Typography>
                    <TextField
                      // label="Line帳號"
                      placeholder="Line帳號"
                      {...field}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 電話 */}
            <Grid item md={4} xs={12}>
              <Controller
                name="mobile"
                control={control}
                rules={{
                  required: "請輸入電話",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      電話
                    </Typography>
                    <TextField
                      placeholder="電話"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 報名課程 */}
            <Grid item xs={6}>
              <Controller
                name="course"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      報名課程
                    </Typography>
                    <Select
                      variant="outlined"
                      fullWidth
                      {...field}
                      style={{
                        maxHeight: "40px",
                        overflow: "hidden",
                      }}
                    >
                      <MenuItem value="無">無</MenuItem>
                      {coursesData?.courses.futureContents.map((item) => (
                        <MenuItem value={item.id}>
                          {item.name +
                            "：" +
                            moment(item.dateStart).format("yyyy-MM-DD") +
                            "～" +
                            moment(item.dateEnd).format("yyyy-MM-DD")}
                        </MenuItem>
                      ))}
                    </Select>
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 上課人數 */}
            <Grid item xs={3}>
              <Controller
                name="numberOfPeople"
                control={control}
                rules={{
                  required: "請輸入人數",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      上課人數
                    </Typography>
                    <TextField
                      placeholder="人數"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Controller
                name="amount"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      課程總金額
                    </Typography>
                    <TextField {...field} disabled={true} fullWidth />
                  </>
                )}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Typography variant="caption">
                若無確定要報名哪一個課程，請您幫忙填寫報名檔期，我們將會協助您安排報名課程
              </Typography>
            </Grid>
            {/* ANCHOR 開始日期 */}
            {course === "無" ? (
              <>
                <Grid item sm={1} xs={2}>
                  <Controller
                    name="startDate"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <Typography
                          variant="body2"
                          style={{ color: "#616161" }}
                        >
                          報名檔期
                        </Typography>
                        <TextField {...field} fullWidth />
                      </>
                    )}
                  />
                </Grid>
                <Grid
                  item
                  style={{
                    alignSelf: "flex-end",
                  }}
                >
                  <Divider
                    orientation="horizontal"
                    style={{
                      width: "20px",
                      height: "2px",
                      marginBottom: "22.5px",
                      color: "#616161",
                    }}
                  />
                </Grid>
                <Grid item sm={1} xs={2}>
                  <Controller
                    name="endDate"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <Typography
                          variant="body2"
                          style={{ color: "#616161", opacity: 0 }}
                        >
                          報名檔期
                        </Typography>
                        <TextField {...field} fullWidth />
                      </>
                    )}
                  />
                </Grid>
                <Grid item classes={{ root: classes.alignFlexEnd }}>
                  <Typography variant="body2">月</Typography>
                </Grid>
              </>
            ) : (
              <Grid item sm={3} xs={4}>
                <Controller
                  name="paymentType"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Typography variant="body2" style={{ color: "#616161" }}>
                        付費方式
                      </Typography>
                      <Select
                        variant="outlined"
                        fullWidth
                        {...field}
                        style={{
                          maxHeight: "40px",
                          overflow: "hidden",
                        }}
                      >
                        <MenuItem value="Credit">信用卡</MenuItem>
                        <MenuItem value="ATM">轉帳匯款</MenuItem>
                      </Select>
                    </>
                  )}
                />
              </Grid>
            )}
            {paymentType === "ATM" && (
              <Grid item classes={{ root: classes.alignFlexEnd }}>
                <Typography>{`請於${moment()
                  .add(3, "day")
                  .format("yyyy/MM/DD HH:mm")}前轉帳匯款`}</Typography>
              </Grid>
            )}
            {/* ANCHOR 備註 */}
            <Grid item xs={12}>
              <Controller
                name="remark"
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field, fieldState: { error } }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    error={error}
                    fullWidth
                  >
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      備註
                    </Typography>
                    <TextareaAutosize
                      {...field}
                      error={error}
                      fullWidth
                      placeholder="備註"
                      style={{
                        resize: "none",
                        height: "120px",
                        fontSize: "1em",
                        padding: "10px",
                      }}
                    />
                    <FormHelperText style={{ bottom: "-30%" }}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item md={5} xs={3}>
              <Controller
                name="vcode"
                control={control}
                rules={{
                  validate: (v) => {
                    if (v !== localStorage.getItem("@fullhouseVcode"))
                      return "驗證碼錯誤";
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2">驗證碼</Typography>
                    <Grid container item spacing={1} direction="row">
                      <Grid item>
                        <TextField
                          {...field}
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid item style={{ marginTop: "10px" }}>
                        <VerificationCode />
                      </Grid>
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </Grid>
          {/* form area end */}
        </Grid>
        {/* button */}

        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            onClick={handleSubmit(_submit)}
            fullWidth
            style={{
              color: "#fff",
              backgroundColor: theme.palette.secondary.light,
              borderRadius: "40px",
              height: "50px",
              marginTop: "10px",
              width: isTable ? "100%" : "30%",
            }}
          >
            送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
